// Kurv-anbefalinger for DAY ET (Fabric).
// Elementet <cart-recommendations> ligger i snippets/cart-drawer.liquid.
// Draweren gentegnes via Section Rendering API ved hver kurvændring, så:
//  - svar caches pr. produkt + kurvindhold (ingen dobbelte kald)
//  - hvis temaet tømmer elementet ved gentegning, fylder vi det igen med det samme

const cache = new Map();

class CartRecommendations extends HTMLElement {
  static observedAttributes = ['data-product-id', 'data-cart-ids'];

  connectedCallback() {
    this.observer = new MutationObserver(() => {
      if (!this.querySelector('.cart-recs')) this.render();
    });
    this.observer.observe(this, { childList: true });
    this.render();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  attributeChangedCallback(_name, oldValue, newValue) {
    if (oldValue !== newValue && this.isConnected) this.render();
  }

  get cacheKey() {
    return `${this.dataset.productId}|${this.dataset.cartIds || ''}`;
  }

  async render() {
    const productId = this.dataset.productId;
    if (!productId) {
      this.innerHTML = '';
      return;
    }

    const key = this.cacheKey;
    if (!cache.has(key)) cache.set(key, this.fetchRecommendations(productId));
    const html = await cache.get(key);

    // Kurven kan have ændret sig, mens vi ventede på svaret
    if (key !== this.cacheKey) return;
    if (this.innerHTML.trim() !== html.trim()) this.innerHTML = html;
  }

  async fetchRecommendations(productId) {
    const root = window.Shopify?.routes?.root ?? '/';
    const sectionId = this.dataset.sectionId || 'cart-recommendations';
    const url =
      `${root}recommendations/products?product_id=${encodeURIComponent(productId)}` +
      `&limit=10&intent=related&section_id=${sectionId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) return '';
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return doc.querySelector('.cart-recs')?.outerHTML ?? '';
    } catch (error) {
      console.error('Kurv-anbefalinger kunne ikke hentes', error);
      return '';
    }
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}